import { useEffect } from 'react';

export interface SEOMeta {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
}

interface SEOHeadProps {
  meta: SEOMeta;
}

export default function SEOHead({ meta }: SEOHeadProps) {
  useEffect(() => {
    document.title = meta.title;

    const setMetaTag = (name: string, content: string, attrName: string = 'name') => {
      let el = document.querySelector(`meta[${attrName}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attrName, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMetaTag('description', meta.description);
    setMetaTag('keywords', meta.keywords);

    const link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (link) {
      link.setAttribute('href', meta.canonicalUrl);
    }

    setMetaTag('og:title', meta.title, 'property');
    setMetaTag('og:description', meta.description, 'property');
    setMetaTag('og:type', meta.ogType || 'website', 'property');
    setMetaTag('og:url', meta.canonicalUrl, 'property');
    if (meta.ogImage) {
      setMetaTag('og:image', meta.ogImage, 'property');
    }

    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', meta.title);
    setMetaTag('twitter:description', meta.description);
    if (meta.ogImage) {
      setMetaTag('twitter:image', meta.ogImage);
    }
  }, [meta]);

  return null;
}